export function isImage(file) {
    var type = file.type.split('/')[0]
    return (type === 'image') ? true : false
}

export function preview(file, callback) {
    var reader = new FileReader();
    
    reader.onload = function (e) {
        callback(e.target.result, file)
    }

    reader.readAsDataURL(file);
}


// WEBPACK FOOTER //
// ./src/SPRINTA/helpers/Image.js